'use client';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Flip from 'gsap/dist/Flip';

// Only register plugins on client side
if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger, Flip);

  // GSAP configuration
  gsap.config({
    nullTargetWarn: false,
  });

  gsap.defaults({
    ease: 'power3.out',
    duration: 0.8,
  });
}

export { gsap, ScrollTrigger, Flip };
